module.exports = __webpack_public_path__ + "img/loading.d52822c1.png";